import React, { createContext, useContext, useState, useEffect } from "react";
import Api from "./baseApi";

export const Context = createContext(null);
export const useConfig = () => useContext(Context);

export default function ConfigProvider({ configCode, children }) {
  const [conf, confSet] = useState(false);

  useEffect(() => {
    const [query] = Api.GET({ path: `/api/abo/vel/config?code=${configCode}` });
    query
      .then((rest) => {
        rest.places.forEach((p) => {
          if (p.notifyMail) p.notifyMail = [p.notifyMail];
        });
        const config = {
          places: { values: rest.places },
          code: configCode,
        };

        if (rest.offer_url) {
          config.offer_url = rest.offer_url;
        }
				if (rest.offer_expiration_date) {
					config.offer_expiration_date = rest.offer_expiration_date;
				}

        let notifyChannel = "onair-fitness";
        let currency = "€";
        let defaultInternationnalCode = "+33";
        let splitPlans = false;
        let footerLogos = [];
        let cgvUrl = "https://onair-fitness.fr/cgv/";
        let baseSite = "https://onair-fitness.fr";

        if (configCode === "onair.es" || configCode === "onair.test") {
          notifyChannel = "onair-fitness-es";
          currency = "€";
          defaultInternationnalCode = "+34";
          window.i18n.changeLanguage("es");
          cgvUrl = "https://www.onair-fitness.es/condiciones-generales-de-venta";
          baseSite = "https://onair-fitness.es";
        }
        if (configCode === "onair.ma") {
          notifyChannel = "onair-fitness-ma";
          currency = "DHS";
          defaultInternationnalCode = "+212";
          splitPlans = true;
          cgvUrl = "https://www.onair-fitness.ma/cgv/";
          footerLogos = ["/logo_cmi.png", "/secure_code_logo.png", "/tn_verified_by_visa.png"];
          baseSite = "https://onair-fitness.ma";
        }

        config.baseSite = baseSite;
        config.notifyChannel = notifyChannel;
        config.currency = currency;
        config.phone = { defaultInternationnalCode };
        config.splitPlans = splitPlans;
        config.footerLogos = footerLogos;
        config.cgvUrl = cgvUrl;
        confSet(config);
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  if (!conf) return null;

  return <Context.Provider value={conf}>{children}</Context.Provider>;
}
